export default __webpack_public_path__ + "static/media/WelcomeBack.03345909.svg";